import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Chart, ArcElement, registerables } from "chart.js";
import HomeService from "../../services/KangarooServices/HomeServices";
import CountUp from "react-countup";

Chart.register(ArcElement);
Chart.register(...registerables);

const statusConfig = {
  pageCount: {
    title: "Pages",
    color: "#28a745",
    icon: "bx bx-file",
  },
  blogCount: {
    title: "Blogs",
    color: "#ffc107",
    icon: "bx bx-news",
  },
  testPreparationCount: {
    title: "Test Preparations",
    color: "#0d6efd",
    icon: "bx bx-book",
  },
  testimonialCount: {
    title: "Testimonials",
    color: "#dc3545",
    icon: "bx bx-message",
  },
  destinationCountryCount: {
    title: "Destination Countries",
    color: "#20c997",
    icon: "bx bx-map",
  },
  menuCount: {
    title: "Menus",
    color: "#6f42c1",
    icon: "bx bx-menu",
  },
  menuTypeCount: {
    title: "Menu Types",
    color: "#fd7e14",
    icon: "bx bx-category",
  },
};

export default function Dashboard() {
  const [countData, setCountData] = useState();
  console.log("🚀 ~ Dashboard ~ countData:", countData);

  useEffect(() => {
    const fetchStatusCount = async () => {
      try {
        const response = await HomeService.getDashboarddata();

        setCountData(response);
      } catch (error) {
        console.log(error);
      }
    };

    fetchStatusCount();
  }, []);
  // Calculate total count from all status
  const getTotalCount = () => {
    if (!countData) return 0;
    return countData.reduce((total, item) => total + item.count, 0);
  };
  const cardData = countData
    ? Object.keys(statusConfig).map((key) => ({
        key,
        count: countData[key] ?? 0,
        ...statusConfig[key],
      }))
    : [];

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <Row>
            {cardData.map((item) => (
              <Col lg={4} md={6} sm={12} key={item.key}>
                <Card className="shadow-sm card-animate border-0">
                  <CardBody>
                    <h6
                      className="fw-semibold text-uppercase"
                      style={{ color: item.color }}
                    >
                      {item.title}
                    </h6>

                    <div className="d-flex justify-content-between align-items-center">
                      <h4
                        className="fs-2 fw-bold"
                        style={{ color: item.color }}
                      >
                        <CountUp
                          start={0}
                          end={item.count}
                          duration={2}
                          separator=","
                        />
                      </h4>

                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: item.color + "20",
                          color: item.color,
                          width: "40px",
                          height: "40px",
                        }}
                      >
                        <i className={`${item.icon} fs-5`} />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
}
